module.exports = __webpack_public_path__ + "img/magento-custom-development_small.e0315614.jpg";